import {
    Routes,
    RouterModule
} from '@angular/router';

import {
    RouterContainerMagicComponent
} from "@magic-xpa/angular";

import {
    CommonModule
} from "@angular/common";
import {
    NgModule
} from '@angular/core';
export const routes: Routes = [





    {
        path: 'login/:pOS/:pItem',

        component: RouterContainerMagicComponent,


        outlet: 'MainForm',



    },

    {
        path: 'loginInvalido/:pMensagem',

        component: RouterContainerMagicComponent,


        outlet: 'MainForm',



    },

    {
        path: 'MenuOpcoes',

        component: RouterContainerMagicComponent,


        outlet: 'MainForm',



        children: [


            {
                path: 'CriarOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'CriarOST2K',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'CriarOST2KEcho',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'CriarOST2KLMS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'FinalizaOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'PesquisaOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'MostrarResultado',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'CriarAcompanhamento',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'ConsultaAcomp',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'AtividadeOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'DetalheItemOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

            {
                path: 'AlterarItemOS',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },


            {
                path: 'AtualizaSenhaUsuario',

                component: RouterContainerMagicComponent,


                outlet: 'MenuForm',



            },

        ]

    },





];

@NgModule({
    imports: [CommonModule,
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class MagicRoutingModule {}